import { useEffect } from 'react';

function AgreementComponent() {
    useEffect(() => {
        window.location.replace(`${window.origin}/AJEX_Express_Conditions_of_Carriage.html`);
    }, []);

    return null;
}

export default AgreementComponent